import { customElement, property } from "lit/decorators.js";
import { DodonaElement } from "components/meta/dodona_element";
import { html, TemplateResult } from "lit";
import { LlmResponse, LlmResponseRating, llmResponseState } from "state/LlmResponse";
import { initTooltips } from "utilities";
import { i18n } from "i18n/i18n";

@customElement("d-draft-response-rating")
export class DraftResponseRating extends DodonaElement {
    @property({ type: Number, attribute: "llm-response-id" })
    llmResponseId: number | null;

    get llmResponse(): LlmResponse {
        return llmResponseState.get(this.llmResponseId);
    }

    updated(): void {
        initTooltips(this);
    }

    render(): TemplateResult {
        return html`
                <div class="rating-icons d-inline-flex">
                    <button
                        type="button"
                        class="btn btn-icon d-btn-success btn-icon-inline p-1"
                        @click="${() => this.toggleRating("good")}">
                        <i class="mdi ${this.llmResponse.rating === "good" ? "mdi-thumb-up" : "mdi-thumb-up-outline"} mdi-18"
                           title=${i18n.t("js.annotation.draft.rating.good")}
                           data-bs-toggle="tooltip"
                           data-bs-placement="top"
                        ></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-icon d-btn-danger btn-icon-inline mt-1 mb-1"
                        @click="${() => this.toggleRating("bad")}">
                        <i class="mdi ${this.llmResponse.rating === "bad" ? "mdi-thumb-down" : "mdi-thumb-down-outline"} mdi-18"
                           title=${i18n.t("js.annotation.draft.rating.bad")}
                           data-bs-toggle="tooltip"
                           data-bs-placement="top"
                        ></i>
                    </button>
                </div>
        `;
    }

    private toggleRating(rating: LlmResponseRating): void {
        this.llmResponse.toggleRating(rating);
    }
}
